<template>
    <div class="w-full h-40px flex items-center px-[15px] cursor-pointer" @click="dialogVisible = true">导入文件</div>
    <el-dialog v-model="dialogVisible" title="导入文件" width="520">
        <div class="import-wrap" :class="{ dragover: isDragOver }" @dragover.prevent="onDragOver"
            @dragleave.prevent="onDragLeave" @drop.prevent="onDrop" @click="onClickUpload">
            <div class="icons">
                <div class="icon ps">Ps</div>
                <div class="icon ai">Ai</div>
                <div class="icon sketch">Sketch</div>
                <div class="icon pdf">PDF</div>
                <div class="icon img">Img</div>
            </div>
            <div class="tip">
                将文件拖到此处，或
                <a class="upload-link" @click.stop="onClickUpload">点击上传</a>
                <input ref="fileInput" type="file" class="hidden-input"
                    accept=".psd,.psb,.ai,.sketch,.pdf,.png,.jpg,.jpeg,.webp,.gif,.svg" @change="onFileChange" />
            </div>
        </div>
    </el-dialog>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { ElDialog, ElMessage } from 'element-plus'
import { resourcerFileUpload } from '@/api/design/resource'
import { useSdkStore } from '@/stores/sdk'

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
const dialogVisible = ref(false)
const isDragOver = ref(false)
const fileInput = ref<HTMLInputElement | null>(null)

const onClickUpload = () => fileInput.value?.click()
const onDragOver = () => { isDragOver.value = true }
const onDragLeave = () => { isDragOver.value = false }
const onDrop = async (e: DragEvent) => {
    isDragOver.value = false
    const files = e.dataTransfer?.files
    if (!files || !files.length) return
    if (files.length > 1) ElMessage.warning('仅支持选择一个文件，已取第一个')
    await handleFile(files[0])
}
const onFileChange = async (e: Event) => {
    const input = e.target as HTMLInputElement
    const files = input.files ? Array.from(input.files) : []
    if (!files.length) return
    if (files.length > 1) ElMessage.warning('仅支持选择一个文件')
    await handleFile(files[0])
    input.value = ''
}

const allowed = ['psd', 'psb', 'ai', 'sketch', 'pdf', 'png', 'jpg', 'jpeg', 'webp', 'gif', 'svg']
const handleFile = async (file: File) => {
    const ext = file.name.split('.').pop()?.toLowerCase() || ''
    if (!allowed.includes(ext)) { ElMessage.error('不支持的文件类型'); return }
    try {
        let res = await resourcerFileUpload(file)
        if (res.data.code == 200) {
            dialogVisible.value = false
            desginsdk.designOpt.showLoading(true)
            await desginsdk.designOpt.requireFile(res.data.data.url)
            desginsdk.designOpt.showLoading(false)
        }
        dialogVisible.value = false
    } catch {
        ElMessage.error('上传失败')
    }
}
</script>
<style lang="scss" scoped>
.import-wrap {
    height: 200px;
    border-radius: 12px;
    background: #f6f7f9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px dashed transparent;
    cursor: pointer;
}

.import-wrap.dragover {
    border-color: #2a66ff;
}

.icons {
    display: flex;
    gap: 16px;
    margin-bottom: 12px;
}

.icon {
    width: 54px;
    height: 54px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
}

.icon.ps {
    background: #3c6cf0;
}

.icon.ai {
    background: #ff8c1a;
}

.icon.sketch {
    background: #f7b731;
}

.icon.pdf {
    background: #e74c3c;
}

.icon.img {
    background: #6c5ce7;
}

.tip {
    color: #8a8f99;
    font-size: 12px;
}

.upload-link {
    color: #2a66ff;
    cursor: pointer;
}

.hidden-input {
    display: none;
}
</style>
